import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { removeSpecialCharacters } from "../../../../helper/removeSpecialCharacters";
import useTags from "../../../../hooks/useTags";
import { suggestionTags } from "../../../../redux/actions/tags";
import Button from "../../../global/Button/Button";
import SearchTagComment from "../../../global/CommentText/SearchTagComment/SearchTagComment";
import DeleteTag from "../../../global/DeleteTag/DeleteTag";
import Input from "../../../global/form/Input/Input";
import "./NewSuggestionTags.scss";

const NewSuggestionTags = ({
  setVisitedSuggestion,
  formData,
  setFormData,
  setCurrentStep,
  onBack
}) => {
  const dispatch = useDispatch();
  const [newTags, setNewTags] = useState([]);
  const [valueInput, setValueInput] = useState("");
  const [listTags, setListTags] = useState(formData.listTags || []);
  const [listTagsID, setListTagsID] = useState(formData.listTagsID || []);
  const tags = useTags();
  const [activeTags, setActiveTag] = useState(false);

  useEffect(() => {
    if (!formData || !formData.content) return;

    const payload = { text: formData.content };
    if (activeTags) {
      dispatch(suggestionTags(payload))
        .then((json) => {
          const uniqueTags = new Set([...listTags]);
          const uniqueTagsID = new Set([...listTagsID]);

          json?.foundTags?.forEach((item) => {
            uniqueTags.add(item?.tag?.name);
            uniqueTagsID.add(item?.tag?.id?.toUpperCase());
          });

          setListTags(Array.from(uniqueTags));
          setListTagsID(Array.from(uniqueTagsID));

          setNewTags(json?.tagsSuggestion);
          setVisitedSuggestion(true);
        })
        .catch(() => { });
    }
  }, [activeTags, formData?.content]);

  const handleCreateTag = () => {
    if (valueInput.trim().length >= 2 && valueInput.trim().length <= 40) {
      const cleanedTag = removeSpecialCharacters(valueInput.trim());

      setListTags((prevTags) => {
        if (!prevTags.includes(cleanedTag)) {
          return [...prevTags, cleanedTag];
        }
        return prevTags;
      });

      setListTagsID((prevTagsID) => {
        if (!prevTagsID.includes(cleanedTag.toUpperCase())) {
          return [...prevTagsID, cleanedTag.toUpperCase()];
        }
        return prevTagsID;
      });

      setValueInput("");
    }
  };

  const handleTagSelection = (item) => {
    const normalizedTag = item.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();

    setListTags((prevTags) => {
      if (!prevTags.some(tag => tag.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase() === normalizedTag)) {
        return [...prevTags, item.name];
      }
      return prevTags;
    });

    setListTagsID((prevTagsID) => {
      if (!prevTagsID.includes(normalizedTag)) {
        return [...prevTagsID, item.id];
      }
      return prevTagsID;
    });

    setValueInput("");
  };

  const resultInput = !valueInput
    ? tags
    : Array.isArray(tags) &&
    tags.filter((item) =>
      item.name.toLowerCase().includes(valueInput.toLowerCase())
    ).filter((item) => item.name !== valueInput);

  const cards = Array.isArray(resultInput) && resultInput.slice(0, 4);

  const removeTag = (name) => {
    setListTags((prevTags) => prevTags.filter(tag => tag !== name));
    setListTagsID((prevTagsID) => prevTagsID.filter(tagID => tagID !== name.toUpperCase()));
  };

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      listTags,
      listTagsID,
    }));
  }, [listTags, listTagsID, setFormData]);

  return (
    <div className="NewSuggestionTags">
      {activeTags || listTags?.length >= 1 ? (
        <div className="suggestion-container">
          <div className="title-tags">
            <h5>Tags</h5> <p>Identificamos estas tags em seu conteúdo</p>
          </div>
          <div className="container-delete-tags">
            {listTags.map((item, key) => (
              <DeleteTag
                item={item}
                key={key}
                onClick={() => removeTag(item)}
              />
            ))}
          </div>
          <div className="container-input-tags">
            <Input
              value={valueInput}
              updateState={setValueInput}
              type="text"
              placeholder="Adicionar tags"
            />
            <Button onClick={handleCreateTag}>
              Criar
            </Button>
          </div>
          {valueInput && cards.length > 0 ? (
            <div className="container-search-tags">
              {cards.map((item, key) => (
                <SearchTagComment
                  item={item}
                  key={key}
                  onClick={() => handleTagSelection(item)}
                />
              ))}
            </div>
          ) : (
            <p className="insert-tag">Insira uma tag para começar a buscar</p>
          )}
        </div>
      ) : (
        <div className="suggestion-container">
          <div className="title-tags">
            <h5>Tags</h5>
          </div>
          <Button
            onClick={() => setActiveTag(true)}
            style={{
              opacity: formData?.content?.length >= 50 ? "1" : "0.4",
              backgroundColor: "#CEEC58",
              cursor: formData?.content?.length >= 50 ? "pointer" : "not-allowed",
            }}
          >
            Clique para detectar tags em seu conteúdo
          </Button>
        </div>
      )}
      <button className="back-button" onClick={onBack}>
        Voltar
      </button>
      <button
        onClick={() => {
          setCurrentStep("Geração de imagem");
        }}
        className="continue-button"
      >
        Continuar
      </button>
    </div>
  );
};

export default NewSuggestionTags;
